define('components/decorators/locations-selector',[
    'jquery',
    'components/decorator',
    // 'components/handlers/filters_locations'
], function ($, decorator, locationUtil) {
    $.extend(companyInfo.decorators, {

        'locations-selector': function () {
            var _this = this;
            //overwrite the select2 clearSearch in prototype, to make sure
            //that the searchterm will stay when you remove focus from the box
            window.Select2.class.multi.prototype.clearSearch = function () {
                var placeholder = this.getPlaceholder(),
                    maxWidth = this.getMaxSearchWidth();
                // CurrentThisInput=(this.search); i used this to get the current select2 element and make further action if required.
                if (this.search.val() !== "") {
                } else if (placeholder !== undefined && this.getVal().length === 0 && this.search.val() === "") {
                    this.search.val(placeholder).addClass("select2-default");
                    this.search.width(maxWidth > 0 ? maxWidth : this.container.css("width"));
                }
            };

            var showName = function (data) {
                if (!data) {
                    return '';
                }
                if (data.name.indexOf(" ") !== -1) {
                    return data.name;
                } else {
                    return data.name.split(" ");
                }
            };

            var showInfo = function (data) {
                if (!data) {
                    return '';
                }
                if (!data.count) {
                    return '';
                }

                var count = data.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                return count;
            };

            var formatRegex = /([^\[\],]+)/g; // removing special characters from selection

            var searchType = function () {
                return $(_this).data("search-type");
            };


            companyInfo.emptySearch = true;
            var select2Elm = $(this).select2({
                placeholder: $(this).attr("data-placeholder"),
                delay: 200,
                dropdownCssClass: 'locations-selector',
                openOnEnter: false,
                //closeOnSelect: true, //CI-7336: this option is by default true
                multiple: true,
                minimumInputLength: 3,
                maximumSelectionSize: ($(this).attr("data-search-type") === 'streets') ? 1 : "",
                ajax: {
                    url: function () {
                        return $(this).attr("data-url") + location.search;
                    },
                    dataType: "json",
                    data: function (params) {
                        if ($(this).attr("data-search-type") === 'streets') {
                            return {
                                searchtype: searchType(),
                                street: params
                            };
                        }
                        else {
                            return {
                                searchtype: searchType(),
                                q: params
                            };
                        }
                    },
                    results: function (data) {
                        return {
                            results: data.results
                        };
                    }
                },
                //format the input field
                adaptContainerCssClass: function (str) {
                    return str.replace('input', '');
                },
                transformVal: function (val) {
                    var newVal = val.trim().match(formatRegex);
                    if (newVal) {
                        return newVal;
                    }
                    return val;
                },
                formatResult: function (data, container) {
                    var template = '<div class="ui-menu-item ui-state-focus"><span class="extra">' + showInfo(data) + '</span>' + showName(data) + '<small></small></div>';
                    return template;
                },
                formatSelection: function (data, container) {
                    return showName(data);
                },
                //keep the search result you already typed
                nextSearchTerm: function (selectedObject, currentSearchTerm) {
                    return currentSearchTerm;
                },
                initSelection: function (element, callback) {
                    if (element.prop("defaultValue")) {
                        var selection = [];
                        var match = element.prop("defaultValue").match(formatRegex) || [];
                        selection = match.map(function(m) {
                          return {name: m.trim()};
                        });

                      if (selection.length) {
                          callback(selection);
                      }
                    }
                    callback();
                },


                //what is submitted
                id: function (obj) {
                    return obj.name;
                }
            });

            /*
             * Change attribute of html tag
             */
            function changeTagAttr(input, attrName, attrValue) {
                if (!input || !attrName || !attrValue) {
                    return false;
                }
                return $(input).attr(attrName, attrValue);
            }

            //check what the selection count is.
            //if selection > 0 than hide the input field, until it gets focus
            var container = $(select2Elm).select2("container");
            if ($(container).find(".select2-choices .select2-search-choice").length > 0) {
                $(container).find(".select2-search-field").addClass("hidden");
            }

            //CI-7336: overwrite abstract method clearSearch to clear the search field when selecting an item
            var field = $(this);
            var housenumberInput = $("#housenumber input");
            var select2 = field.data('select2');

            if (field.attr("data-search-type") === 'streets') {
                // If street input is empty, make house-number field readonly
                if (field.val() === "") {
                    changeTagAttr(housenumberInput, "readonly", true);
                    $(housenumberInput).css("cursor", "not-allowed");
                } else {
                    changeTagAttr(housenumberInput, "readonly", false);
                    $(housenumberInput).css("cursor", "default");
                }
                // Removing house number if street name field is cleared
                field.on('select2-removing', function () {
                    $(housenumberInput).val(null).trigger('change');
                });
                // word wrap if street name is too big for split input
                $("#street li").css({"width": "100%", "word-wrap": "break-word"});
            }

            field.on('select2-selecting', function () {
                select2.search.addClass("select2-input--hidden");
                select2.search.focus();
            });

        }
    });

});

